<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
        <h1 class="text-center grey--text text--darken-2 mb-3">
          Our Product
        </h1>
        <p class="text-center">
          Our objective is to make the storage process as easy and convenient as
          possible. We take care of all of the hard work so you don’t have to
          lift a finger.
        </p>
      </v-col>
    </v-row>
    <v-container>
      <v-row align="stretch" justify="center">
        <v-col class="text-center mx-md-5" cols="12" sm="6" md="4">
          <v-card class="card-responsive">
            <v-img
              class="white--text align-end"
              height="200px"
              :src="require('../assets/StorageByItem-min.png')"
            >
              <v-card-title>1</v-card-title>
            </v-img>

            <v-card-text class="text--primary">
              <h2 class="orange--text mb-2">STORAGE BY THE ITEM</h2>
              <div>
                Never visit a warehouse again. Book your preferred date and time
                on our website, and we’ll go straight to your doorstep.
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="text-center mx-md-5" cols="12" sm="6" md="4">
          <v-card class="card-responsive">
            <v-img
              class="white--text align-end"
              height="200px"
              :src="require('../assets/StorageBySQM-min.png')"
            >
              <v-card-title>2</v-card-title>
            </v-img>

            <v-card-text class="text--primary">
              <h2 class="orange--text mb-2">STORAGE BY THE SQM</h2>
              <div>
                We automatically take care of the packing, heavy lifting and
                taking photos of your items.
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "HowItWorks",

  data: () => ({}),
};
</script>

<style scoped>
.card-responsive {
  height: 100%;
}
</style>
